export const weightTypes = {
    REFERRAL : "Referral",
    PROGRAMME: "Programme"
}